@let row = this.row();
@let group = this.group();
@let rowIndex = this.rowIndex();
@let first = row.documents[0];

<button
    qpxButton
    matIconButton
    size="sm"
    cdkDragHandle
    [matMenuTriggerFor]="actions"
    class="grip compact"
    [disabled]="disabled()"
    [attr.aria-label]="`Actions for ${row.name}`"
>
    <ng-icon qpx size="sm" name="lucideGripVertical" />
</button>
<div class="header-name">
    <span class="name-width" aria-hidden="true">{{ row.name }}</span>
    <mat-form-field
        qpxInput
        size="sm"
        class="w-full alt-bg"
        subscriptSizing="dynamic"
        ><input
            matInput
            [id]="`${actionId()}-requirement-${row.id}`"
            [attr.aria-label]="
                first
                    ? `Requirement name for ${first.title}`
                    : 'Requirement name'
            "
            maxlength="200"
            [disabled]="disabled()"
            [ngModel]="row.name"
            (ngModelChange)="draft.renameRow(row.id, $event); changed.emit()"
    /></mat-form-field>
</div>
<button
    qpxButton
    matIconButton
    size="sm"
    class="action compact"
    [disabled]="disabled()"
    [attr.aria-label]="`Delete ${row.name}`"
    (click)="remove()"
>
    <ng-icon qpx size="sm" name="lucideTrash2" context="destructive" />
</button>
<mat-menu #actions="matMenu" xPosition="after" yPosition="below">
    <button
        mat-menu-item
        type="button"
        [disabled]="disabled() || rowIndex === 0"
        [attr.aria-label]="`Move ${row.name} up`"
        (click)="moveTo(group.key, rowIndex - 1)"
    >
        <ng-icon qpx size="sm" name="lucideArrowUp" matMenuItemIcon /><span
            >Move up</span
        >
    </button>
    <button
        mat-menu-item
        type="button"
        [disabled]="disabled() || rowIndex === group.rows.length - 1"
        [attr.aria-label]="`Move ${row.name} down`"
        (click)="moveTo(group.key, rowIndex + 1)"
    >
        <ng-icon qpx size="sm" name="lucideArrowDown" matMenuItemIcon /><span
            >Move down</span
        >
    </button>
    <button
        mat-menu-item
        type="button"
        [disabled]="disabled() || draft.groups().length < 2"
        [matMenuTriggerFor]="moveMenu"
        [attr.aria-label]="`Move ${row.name} to section`"
    >
        <ng-icon
            qpx
            size="sm"
            name="lucideArrowRightLeft"
            matMenuItemIcon
        /><span>Move to section</span>
    </button>
</mat-menu>
<mat-menu #moveMenu="matMenu">
    @for (target of draft.groups(); track target.key) {
        <button
            mat-menu-item
            type="button"
            [disabled]="target.key === group.key"
            (click)="moveTo(target.key, target.rows.length)"
        >
            {{ target.name }}
        </button>
    }
</mat-menu>
